const ActionType = {
  GET_DEVICE_STATS_BY_STATUS: 'analytics/get-device-stats-by-status',
}

export default ActionType
